export default function unescape(value) {
    const doc = new DOMParser().parseFromString(value, 'text/html');
    if (!doc) {
        return null;
    }

    return doc?.body?.innerHTML;
}
